import { alpha, darken } from '@mui/material'
import { colors } from './colors.theme'

export const tableContainerTheme = {
  root: { border: 'none' },
}

export const tableTheme = {
  root: {
    borderCollapse: 'unset' as 'unset',

    '& .MuiTableRow-head': {
      /* '& th': {
        textTransform: 'uppercase',
      },

      '& th:first-of-type': {
        borderBottomLeftRadius: '8px',
        borderTopLeftRadius: '8px',
      },
      '& th:last-of-type': {
        borderBottomRightRadius: '8px',
        borderTopRightRadius: '8px',
      }, */
    },
  },
}

export const tableCellTheme = {
  root: {
    borderBottom: `1px dashed ${alpha(colors.white, 0.05)}!important`,
  },
  head: {
    backgroundColor: `${colors.paper3} !important`,
    fontWeight: 700,
    color: `${alpha(colors.white, 0.5)} !important`,
    '.orange &': {
      borderBottom: `1px solid ${colors.orange} !important`,
      backgroundColor: `${darken(colors.orange, 0.3)} !important`,
    },
  },
  body: {
    backgroundColor: 'inherit',
  },
}

export const tableRowTheme = {
  // root: {
  //   backgroundColor: paper2,
  //   '&:hover': {
  //     backgroundColor: `${paper3} !important`,
  //   },
  // },
}
